import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { FiCheck } from 'react-icons/fi';
import api from '../../../system/client/src/services/api';
import { typeInfo, isOverdue, fmtWhen } from '../../Components/activityTypes';
import './RemindersCard.css';

const SHOW = 6;

const toTitleCase = (value = '') =>
    value.toLowerCase().replace(/\b([a-z])/g, (c) => c.toUpperCase());

/* "To do" — the reminders you've set on notes, calls and meetings, overdue
 * first, then soonest. Ticking one off removes it from the list. */
const RemindersCard = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState(null);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        api.get('activities/upcoming')
            .then(setItems)
            .catch(() => setItems([]));
    }, []);

    const markDone = async (e, a) => {
        e.stopPropagation();
        try {
            await api.patch(`activities/${a.id}`, { done: true });
            setItems((prev) => prev.filter((x) => x.id !== a.id));
            message.success('Done');
        } catch {
            message.error('Could not update the reminder');
        }
    };

    if (items === null) return null;

    const overdue = items.filter(isOverdue).length;
    const shown = showAll ? items : items.slice(0, SHOW);

    return (
        <section className="section todo-section">
            <div className="section-head">
                <div>
                    <span className="kicker">To do</span>
                    <h2>Coming up.</h2>
                </div>
                {items.length > 0 && (
                    <span className="meta">
                        {overdue > 0 ? `${overdue} overdue · ` : ''}{items.length} open
                    </span>
                )}
            </div>

            {items.length === 0 ? (
                <div className="empty">
                    <p>
                        Nothing to do. Log a call or meeting on a trader's page and tick
                        "Remind me" to see it here.
                    </p>
                </div>
            ) : (
                <>
                    <ul className="todo-list">
                        {shown.map((a) => {
                            const { Icon, label } = typeInfo(a.type);
                            const late = isOverdue(a);
                            return (
                                <li
                                    key={a.id}
                                    className="todo-item"
                                    onClick={() => navigate(`/traders/${a.trader_id}`)}
                                >
                                    <span className={`todo-icon type-${a.type}`} title={label}>
                                        <Icon aria-label={label} />
                                    </span>
                                    <div className="todo-main">
                                        <span className="todo-co">
                                            {a.company_name ? toTitleCase(a.company_name) : 'Unknown company'}
                                        </span>
                                        <span className="todo-body">{a.body}</span>
                                    </div>
                                    <span className={`todo-when${late ? ' overdue' : ''}`}>
                                        {late ? 'Overdue · ' : ''}{fmtWhen(a.remind_at)}
                                    </span>
                                    <button
                                        type="button"
                                        className="todo-done"
                                        onClick={(e) => markDone(e, a)}
                                        aria-label="Mark as done"
                                        title="Mark as done"
                                    >
                                        <FiCheck />
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                    {items.length > SHOW && (
                        <button
                            type="button"
                            className="btn btn-secondary todo-more"
                            onClick={() => setShowAll((v) => !v)}
                        >
                            {showAll ? 'Show fewer' : `Show all ${items.length}`}
                        </button>
                    )}
                </>
            )}
        </section>
    );
};

export default RemindersCard;
